import React from "react";
import "./ITES.css";
import ites from "../../../../assets/images/ITES/Group 39234.png";
import { useTranslation } from "react-i18next";

function ITES() {
  const { t } = useTranslation();
  return (
    <div className="ITES">
      <div className="ITES-container-1">
        <div className="ITES-text-main">
          <div className="ITES-text-head">
            <h2> {t("ITES IT Enabled Services")}</h2>
          </div>
          <div className="ITES-text-para">
            <p>
              {t("The necessity to integrate emerging technologies in an")}      
            </p>
            <p>
              {t("We ensure the functioning of client systems is optimized ")}
            </p>
          </div>
        </div>
      </div>
      <div className="ITES-container-2">
        <img src={ites} className="ITES-img" alt="ites"/>
      </div>
    </div>
  );
}

export default ITES;
